import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    root: {
        position: "absolute",
        padding: "3px 4px 1px 6px",
        margin: "78px 20px",
        border: "solid 1px #7b8892",
        borderRadius: "2px",
        backgroundColor: "#dfe2e4",
        zIndex: 1
    },
    text: {
        fontSize: "10px",
        color: "#7a8892",
        fontFamily: "OpenSans",
        fontWeight: "bold",
        fontStretch: "normal"
    }
}));

export default function AutoSave() {
    const classes = useStyles();

    return (
        <>
            <div className={classes.root}>
                <Typography variant='subtitle1' className={classes.text}>
                    SAVING...
                </Typography>
            </div>
        </>
    )
}